(function (Drupal, $, once) {
  "use strict";
  Drupal.behaviors.fisheries = {
    attach: function (context) {
      $(function () {
        $(once("map-init", "#fisheries-map", context)).each(function () {
          function initMap() {
            if ($("body").hasClass("page-node-type-homepage")) {
              var map = L.map("fisheries-map", {
                zoomSnap: 1,
                scrollWheelZoom: false,
              }).setView([-31, 133], 4);
            } else {
              var map = L.map("fisheries-map", {
                zoomSnap: 1,
              }).setView([-31, 133], 4);
            }

            L.tileLayer(
              "https://api.mapbox.com/styles/v1/joebecobb/clbnhv8rv001n15pj6qmzwrxr/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoiam9lYmVjb2JiIiwiYSI6ImNsYWFucGlrNzA5d2MzdnBnY25ia2ZhOTcifQ.tUFU6BobYraKobnX0LtkpA",
              {
                maxZoom: 18,
                minZoom: 4,
              }
            ).addTo(map);

            var locationIcon = L.icon({
              iconUrl: "/themes/custom/afma/images/map-marker.svg",
              iconSize: [28, 40],
              iconAnchor: [14, 40],
              popupAnchor: [0, -40],
            });
            var locationIconRed = L.icon({
              iconUrl: "/themes/custom/afma/images/map-marker-red.svg",
              iconSize: [28, 40],
              iconAnchor: [14, 40],
              popupAnchor: [0, -40],
            });

            var layers = [];
            var markers = [];

            function hideAreas() {
              layers.forEach((layer) => {
                map.removeLayer(layer);
              });
              markers.forEach((marker) => {
                marker.setIcon(locationIcon);
              });
            }

            $(once(
              "interactive-fisheries-map-item",
              ".interactive-fisheries-map__item"
            )).each(function () {
              var elem = $(this);
              var kml = elem.data("kml");
              var title = elem.data("title");
              var lat = elem.data("lat");
              var long = elem.data("long");

              var link = elem
                .find(".interactive-fisheries-map__item--link")
                .clone()
                .html();
              var image = elem
                .find(".interactive-fisheries-map__item--image-landmark")
                .clone()
                .html();
              var id = elem.data("id");
              var lay = L.kmzLayer();

              elem
                .find(".interactive-fisheries-map__item--image-landmark")
                .remove();
              // console.log(kml);

              //items with kml/kmz file
              if (kml) {
                lay.load(kml);

                lay.on("load", function (e) {
                  var center = e.layer.getBounds().getCenter();
                  //Overriding Marker position
                  if (lat && long) {
                    center.lat = lat;
                    center.lng = long;
                  }

                  layers.push(e.layer);

                  var marker = L.marker(center, {
                    icon: locationIcon,
                  });

                  marker.bindPopup(`
                    <div class="custom-popup">
                      <div class="popup-header">${image}</div>
                      <div class="popup-body">
                        <h5>${title}</h5>
                        ${link}
                      </div>
                    </div>
                  `);

                  markers[id] = marker;

                  marker.addTo(map).on("popupopen", function (f) {
                    hideAreas();
                    marker.setIcon(locationIconRed);
                    e.layer.addTo(map);
                    elem.addClass("is-active");
                    elem.siblings().removeClass("is-active");

                    if ($("body").hasClass("page-node-type-homepage")) {
                      var bounds = e.layer.getBounds().getCenter();
                      map.flyTo(bounds, 4, {
                        duration: 0.3,
                      });
                    } else {
                      scrollInsideContainer(elem);
                      var bounds = e.layer.getBounds();
                      map.flyToBounds(bounds, {
                        animate: true,
                        duration: 0.3,
                      });
                    }
                    // $(".fisheries-map__popup").html(popupMarkup);
                    $(".fisheries-map__clear").fadeIn(300);
                  });
                });
              } else {
                //items without kml/kmz file

                var center = [lat, long];
                var marker = L.marker(center, {
                  icon: locationIcon,
                });

                var layer = marker.addTo(map);

                marker.bindPopup(`
                    <div class="custom-popup">
                      <div class="popup-header">${image}</div>
                      <div class="popup-body">
                        <h5>${title}</h5>
                        ${link}
                      </div>
                    </div>
                  `);

                markers[id] = marker;

                marker.addTo(map).on("popupopen", function (f) {
                  hideAreas();
                  marker.setIcon(locationIconRed);
                  layer.addTo(map);
                  elem.addClass("is-active");
                  elem.siblings().removeClass("is-active");

                  if (!$("body").hasClass("page-node-type-homepage")) {
                    scrollInsideContainer(elem);
                  }

                  map.flyTo(center, 4, {
                    duration: 0.3,
                  });
                  $(".fisheries-map__clear").fadeIn(300);
                });
              }

              elem.on("click", function () {
                markers[id].openPopup();
              });

              function scrollInsideContainer(elem) {
                var diff =
                  $(elem).offset().top -
                  $(elem).parent().offset().top +
                  $(elem).parent().scrollTop();
                console.log(diff);

                $(elem).parent().stop().animate({
                  scrollTop: diff,
                });
              }

              //reset map button
              $(document).on("click", ".fisheries-map__clear", function () {
                var $this = $(this);
                $this.fadeOut(300);
                hideAreas();

                $(".interactive-fisheries-map__item.is-active").removeClass(
                  "is-active"
                );

                $(".fisheries-map__popup__wrapper .fisheries-map__popup")
                  .children()
                  .remove();

                map.flyTo([-31, 133], 4, {
                  animate: true,
                  duration: 0.3,
                });
              });
            });

            $(document).on(
              "click",
              ".leaflet-popup .leaflet-popup-close-button",
              function () {
                $(".fisheries-map__clear").click();
              }
            );
          }

          if (window.matchMedia("(min-width: 1024px)").matches) {
            initMap();
          }

          $(window).on("scroll", function () {
            if (
              window.matchMedia("(min-width: 1024px)").matches &&
              !$("#fisheries-map").hasClass("leaflet-container")
            ) {
              initMap();
            }
          });

          $(once(
            "splide-init",
            "body.page-node-type-homepage .interactive-fisheries-map__wrapper"
          )).each(function () {
            var splide = new Splide(
              $(this).find(".interactive-fisheries-map__items.splide")[0],
              {
                arrows: false,
                fixedWidth: "235px",
                gap: "30px",
                mediaQuery: "min",
                breakpoints: {
                  768: {
                    destroy: true,
                  },
                },
              }
            );

            splide.mount();
          });
        });
      });
    },
  };
})(Drupal, jQuery, once);
